import type { CoreEnv, CoreRequest, CoreUser } from '@eventbrite/legacy-infra.context-types';
import React from 'react';

export const useEnvContext = () => {
    const value = React.useContext(EnvContext);

    if (value === undefined) {
        throw new Error('useEnvContext must be used within EnvProvider');
    }

    return value;
};

interface EnvContextShape {
    env: CoreEnv;
    user?: CoreUser;
    request?: CoreRequest;
    isBotRequest?: boolean;
}

export const EnvContext = React.createContext<Partial<EnvContextShape>>({});
